// Copyright (c) 2021 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file legebill/site/postexpectation/v4/post_expectation.proto (package legebill.site.post_expectation.v4, syntax proto3)
/* eslint-disable */

// buf:lint:ignore PACKAGE_DIRECTORY_MATCH
// buf:lint:ignore DIRECTORY_SAME_PACKAGE

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../../../google/type/date_pb";
import { file_google_type_date } from "../../../../google/type/date_pb";
import type { Workday, WorkdaySchema } from "../../../type/workday_pb";
import { file_legebill_type_workday } from "../../../type/workday_pb";
import type { DayOfWeek } from "../../../../google/type/dayofweek_pb";
import { file_google_type_dayofweek } from "../../../../google/type/dayofweek_pb";
import { file_google_api_annotations } from "../../../../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file legebill/site/postexpectation/v4/post_expectation.proto.
 */
export const file_legebill_site_postexpectation_v4_post_expectation: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_type_date, file_legebill_type_workday, file_google_type_dayofweek, file_google_api_annotations]);

/**
 * @generated from message legebill.site.post_expectation.v4.PostExpectation
 */
export type PostExpectation = Message<"legebill.site.post_expectation.v4.PostExpectation"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * the uuid of the resource
   *
   * @generated from field: string id = 2;
   */
  id: string;

  /**
   * non-unique, chosen by user, sensible default might be `$teamName Post Expectation`
   *
   * @generated from field: string label = 3;
   */
  label: string;

  /**
   * see https://stackoverflow.com/questions/1091372/getting-the-clients-time-zone-and-offset-in-javascript
   * the time zone that this date information is displayed in (i.e. not in UTC!)
   *
   * @generated from field: string iana_tz_name = 4;
   */
  ianaTzName: string;

  /**
   * yyyyMMdd date (any digits beyond 8 will be truncated)
   * the current interval start (or for creation, the start of new expectation interval)
   *
   * @generated from field: string start_local_date_time = 5;
   */
  startLocalDateTime: string;

  /**
   * @generated from field: legebill.site.post_expectation.v4.IntervalDuration interval_duration = 6;
   */
  intervalDuration?: IntervalDuration;

  /**
   * @generated from oneof legebill.site.post_expectation.v4.PostExpectation.user_list_type
   */
  userListType: {
    /**
     * these lists may both be empty, or at most one list can be non-empty
     *
     * @generated from field: legebill.site.post_expectation.v4.MemberList user_include_list = 7;
     */
    value: MemberList;
    case: "userIncludeList";
  } | {
    /**
     * @generated from field: legebill.site.post_expectation.v4.MemberList user_exclude_list = 8;
     */
    value: MemberList;
    case: "userExcludeList";
  } | { case: undefined; value?: undefined };

  /**
   * receive summaries (and alerts)
   *
   * @generated from field: repeated string summary_recipient_membership_ids = 9;
   */
  summaryRecipientMembershipIds: string[];

  /**
   * The standard workdays are used for time posting expectations, unless
   * a membership defines its own custom workdays.
   *
   * If a day of the week is not included during the creation of the post
   * expectation, then the expected hours is set to 0 for that day. The
   * PostExpectation resource must include the full week including days with
   * 0 hours if is returned in an RPC response.
   *
   * There must be at least one workday with expected hours > 0.
   * default_work_days was deprecated. Use standard_workdays.
   *
   * @generated from field: repeated legebill.type.Workday standard_workdays = 13;
   */
  standardWorkdays: Workday[];

  /**
   * how many hours after should user be reminded if expectation not met?
   *
   * @generated from field: uint64 remind_user_hours = 11;
   */
  remindUserHours: bigint;

  /**
   * UI should default to before as default drop-down value re new post goals being created
   *
   * @generated from field: legebill.site.post_expectation.v4.PostExpectation.RemindHoursType remind_hours_type = 14;
   */
  remindHoursType: PostExpectation_RemindHoursType;

  /**
   * how many hours after interval end should summary & alerts be sent?
   * should warn user send_summaries_hours is < remind_user_hours
   *
   * @generated from field: uint64 send_summaries_hours = 12;
   */
  sendSummariesHours: bigint;
};

/**
 * Describes the message legebill.site.post_expectation.v4.PostExpectation.
 * Use `create(PostExpectationSchema)` to create a new message.
 */
export const PostExpectationSchema: GenMessage<PostExpectation> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 0);

/**
 * @generated from enum legebill.site.post_expectation.v4.PostExpectation.RemindHoursType
 */
export enum PostExpectation_RemindHoursType {
  /**
   * to handle transition period gracefully, if UNSPECIFIED treat as REMIND_AFTER
   *
   * @generated from enum value: REMIND_HOURS_TYPE_UNSPECIFIED = 0;
   */
  REMIND_HOURS_TYPE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: REMIND_BEFORE = 1;
   */
  REMIND_BEFORE = 1,

  /**
   * @generated from enum value: REMIND_AFTER = 2;
   */
  REMIND_AFTER = 2,
}

/**
 * Describes the enum legebill.site.post_expectation.v4.PostExpectation.RemindHoursType.
 */
export const PostExpectation_RemindHoursTypeSchema: GenEnum<PostExpectation_RemindHoursType> = /*@__PURE__*/
  enumDesc(file_legebill_site_postexpectation_v4_post_expectation, 0, 0);

/**
 * @generated from message legebill.site.post_expectation.v4.MemberList
 */
export type MemberList = Message<"legebill.site.post_expectation.v4.MemberList"> & {
  /**
   * @generated from field: repeated string membership_ids = 1;
   */
  membershipIds: string[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.MemberList.
 * Use `create(MemberListSchema)` to create a new message.
 */
export const MemberListSchema: GenMessage<MemberList> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 1);

/**
 * @generated from message legebill.site.post_expectation.v4.IntervalDuration
 */
export type IntervalDuration = Message<"legebill.site.post_expectation.v4.IntervalDuration"> & {
  /**
   * Must be from 1 to 12 inclusive
   *
   * @generated from field: uint32 units = 1;
   */
  units: number;

  /**
   * @generated from field: legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType unit_type = 2;
   */
  unitType: IntervalDuration_IntervalUnitType;
};

/**
 * Describes the message legebill.site.post_expectation.v4.IntervalDuration.
 * Use `create(IntervalDurationSchema)` to create a new message.
 */
export const IntervalDurationSchema: GenMessage<IntervalDuration> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 2);

/**
 * @generated from enum legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType
 */
export enum IntervalDuration_IntervalUnitType {
  /**
   * @generated from enum value: INTERVAL_UNSPECIFIED = 0;
   */
  INTERVAL_UNSPECIFIED = 0,

  /**
   * @generated from enum value: WEEKS = 1;
   */
  WEEKS = 1,

  /**
   * @generated from enum value: MONTHS = 2;
   */
  MONTHS = 2,
}

/**
 * Describes the enum legebill.site.post_expectation.v4.IntervalDuration.IntervalUnitType.
 */
export const IntervalDuration_IntervalUnitTypeSchema: GenEnum<IntervalDuration_IntervalUnitType> = /*@__PURE__*/
  enumDesc(file_legebill_site_postexpectation_v4_post_expectation, 2, 0);

/**
 * @generated from message legebill.site.post_expectation.v4.CreatePostExpectationRequest
 */
export type CreatePostExpectationRequest = Message<"legebill.site.post_expectation.v4.CreatePostExpectationRequest"> & {
  /**
   * PostExpectation.id is ignored by CreatePostExpectation
   *
   * @generated from field: legebill.site.post_expectation.v4.PostExpectation post_expectation = 1;
   */
  postExpectation?: PostExpectation;
};

/**
 * Describes the message legebill.site.post_expectation.v4.CreatePostExpectationRequest.
 * Use `create(CreatePostExpectationRequestSchema)` to create a new message.
 */
export const CreatePostExpectationRequestSchema: GenMessage<CreatePostExpectationRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 3);

/**
 * @generated from message legebill.site.post_expectation.v4.ChangeMemberListTypeRequest
 */
export type ChangeMemberListTypeRequest = Message<"legebill.site.post_expectation.v4.ChangeMemberListTypeRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * defines which site members a post expectation applies to
   *
   * @generated from field: legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType member_list_type = 3;
   */
  memberListType: ChangeMemberListTypeRequest_MemberListType;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.
 * Use `create(ChangeMemberListTypeRequestSchema)` to create a new message.
 */
export const ChangeMemberListTypeRequestSchema: GenMessage<ChangeMemberListTypeRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 4);

/**
 * @generated from enum legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType
 */
export enum ChangeMemberListTypeRequest_MemberListType {
  /**
   * @generated from enum value: MEMBER_LIST_UNION_TYPE_UNSPECIFIED = 0;
   */
  MEMBER_LIST_UNION_TYPE_UNSPECIFIED = 0,

  /**
   * applies to all site members
   *
   * @generated from enum value: ALL_MEMBERS = 1;
   */
  ALL_MEMBERS = 1,

  /**
   * applies to specified site members
   *
   * @generated from enum value: INCLUDE_MEMBERS = 2;
   */
  INCLUDE_MEMBERS = 2,

  /**
   * applies to all other site members (not present in list)
   *
   * @generated from enum value: EXCLUDE_MEMBERS = 3;
   */
  EXCLUDE_MEMBERS = 3,
}

/**
 * Describes the enum legebill.site.post_expectation.v4.ChangeMemberListTypeRequest.MemberListType.
 */
export const ChangeMemberListTypeRequest_MemberListTypeSchema: GenEnum<ChangeMemberListTypeRequest_MemberListType> = /*@__PURE__*/
  enumDesc(file_legebill_site_postexpectation_v4_post_expectation, 4, 0);

/**
 * @generated from message legebill.site.post_expectation.v4.AddToMemberListRequest
 */
export type AddToMemberListRequest = Message<"legebill.site.post_expectation.v4.AddToMemberListRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * @generated from field: string member_id = 3;
   */
  memberId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.AddToMemberListRequest.
 * Use `create(AddToMemberListRequestSchema)` to create a new message.
 */
export const AddToMemberListRequestSchema: GenMessage<AddToMemberListRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 5);

/**
 * @generated from message legebill.site.post_expectation.v4.AddToMemberListResponse
 */
export type AddToMemberListResponse = Message<"legebill.site.post_expectation.v4.AddToMemberListResponse"> & {
};

/**
 * Describes the message legebill.site.post_expectation.v4.AddToMemberListResponse.
 * Use `create(AddToMemberListResponseSchema)` to create a new message.
 */
export const AddToMemberListResponseSchema: GenMessage<AddToMemberListResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 6);

/**
 * @generated from message legebill.site.post_expectation.v4.RemoveFromMemberListRequest
 */
export type RemoveFromMemberListRequest = Message<"legebill.site.post_expectation.v4.RemoveFromMemberListRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * @generated from field: string member_id = 3;
   */
  memberId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.RemoveFromMemberListRequest.
 * Use `create(RemoveFromMemberListRequestSchema)` to create a new message.
 */
export const RemoveFromMemberListRequestSchema: GenMessage<RemoveFromMemberListRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 7);

/**
 * @generated from message legebill.site.post_expectation.v4.RemoveFromMemberListResponse
 */
export type RemoveFromMemberListResponse = Message<"legebill.site.post_expectation.v4.RemoveFromMemberListResponse"> & {
};

/**
 * Describes the message legebill.site.post_expectation.v4.RemoveFromMemberListResponse.
 * Use `create(RemoveFromMemberListResponseSchema)` to create a new message.
 */
export const RemoveFromMemberListResponseSchema: GenMessage<RemoveFromMemberListResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 8);

/**
 * @generated from message legebill.site.post_expectation.v4.ListPostExpectationsRequest
 */
export type ListPostExpectationsRequest = Message<"legebill.site.post_expectation.v4.ListPostExpectationsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListPostExpectationsRequest.
 * Use `create(ListPostExpectationsRequestSchema)` to create a new message.
 */
export const ListPostExpectationsRequestSchema: GenMessage<ListPostExpectationsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 9);

/**
 * @generated from message legebill.site.post_expectation.v4.ListPostExpectationsResponse
 */
export type ListPostExpectationsResponse = Message<"legebill.site.post_expectation.v4.ListPostExpectationsResponse"> & {
  /**
   * @generated from field: repeated legebill.site.post_expectation.v4.PostExpectation post_expectations = 1;
   */
  postExpectations: PostExpectation[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListPostExpectationsResponse.
 * Use `create(ListPostExpectationsResponseSchema)` to create a new message.
 */
export const ListPostExpectationsResponseSchema: GenMessage<ListPostExpectationsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 10);

/**
 * @generated from message legebill.site.post_expectation.v4.AddSummaryRecipientRequest
 */
export type AddSummaryRecipientRequest = Message<"legebill.site.post_expectation.v4.AddSummaryRecipientRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * @generated from field: string summary_recipient_membership_id = 3;
   */
  summaryRecipientMembershipId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.AddSummaryRecipientRequest.
 * Use `create(AddSummaryRecipientRequestSchema)` to create a new message.
 */
export const AddSummaryRecipientRequestSchema: GenMessage<AddSummaryRecipientRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 11);

/**
 * @generated from message legebill.site.post_expectation.v4.AddSummaryRecipientResponse
 */
export type AddSummaryRecipientResponse = Message<"legebill.site.post_expectation.v4.AddSummaryRecipientResponse"> & {
};

/**
 * Describes the message legebill.site.post_expectation.v4.AddSummaryRecipientResponse.
 * Use `create(AddSummaryRecipientResponseSchema)` to create a new message.
 */
export const AddSummaryRecipientResponseSchema: GenMessage<AddSummaryRecipientResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 12);

/**
 * @generated from message legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest
 */
export type RemoveSummaryRecipientRequest = Message<"legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * @generated from field: string summary_recipient_membership_id = 3;
   */
  summaryRecipientMembershipId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.RemoveSummaryRecipientRequest.
 * Use `create(RemoveSummaryRecipientRequestSchema)` to create a new message.
 */
export const RemoveSummaryRecipientRequestSchema: GenMessage<RemoveSummaryRecipientRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 13);

/**
 * @generated from message legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse
 */
export type RemoveSummaryRecipientResponse = Message<"legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse"> & {
};

/**
 * Describes the message legebill.site.post_expectation.v4.RemoveSummaryRecipientResponse.
 * Use `create(RemoveSummaryRecipientResponseSchema)` to create a new message.
 */
export const RemoveSummaryRecipientResponseSchema: GenMessage<RemoveSummaryRecipientResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 14);

/**
 * @generated from message legebill.site.post_expectation.v4.ArchivePostExpectationRequest
 */
export type ArchivePostExpectationRequest = Message<"legebill.site.post_expectation.v4.ArchivePostExpectationRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ArchivePostExpectationRequest.
 * Use `create(ArchivePostExpectationRequestSchema)` to create a new message.
 */
export const ArchivePostExpectationRequestSchema: GenMessage<ArchivePostExpectationRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 15);

/**
 * @generated from message legebill.site.post_expectation.v4.SetStandardWorkdayRequest
 */
export type SetStandardWorkdayRequest = Message<"legebill.site.post_expectation.v4.SetStandardWorkdayRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * @generated from field: legebill.type.Workday workday = 3;
   */
  workday?: Workday;
};

/**
 * Describes the message legebill.site.post_expectation.v4.SetStandardWorkdayRequest.
 * Use `create(SetStandardWorkdayRequestSchema)` to create a new message.
 */
export const SetStandardWorkdayRequestSchema: GenMessage<SetStandardWorkdayRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 16);

/**
 * @generated from message legebill.site.post_expectation.v4.SetCustomWorkdayRequest
 */
export type SetCustomWorkdayRequest = Message<"legebill.site.post_expectation.v4.SetCustomWorkdayRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;

  /**
   * @generated from field: legebill.type.Workday workday = 3;
   */
  workday?: Workday;
};

/**
 * Describes the message legebill.site.post_expectation.v4.SetCustomWorkdayRequest.
 * Use `create(SetCustomWorkdayRequestSchema)` to create a new message.
 */
export const SetCustomWorkdayRequestSchema: GenMessage<SetCustomWorkdayRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 17);

/**
 * @generated from message legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest
 */
export type UnsetCustomWorkdaysRequest = Message<"legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;

  /**
   * @generated from field: repeated google.type.DayOfWeek days_of_week = 3;
   */
  daysOfWeek: DayOfWeek[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.UnsetCustomWorkdaysRequest.
 * Use `create(UnsetCustomWorkdaysRequestSchema)` to create a new message.
 */
export const UnsetCustomWorkdaysRequestSchema: GenMessage<UnsetCustomWorkdaysRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 18);

/**
 * @generated from message legebill.site.post_expectation.v4.ListCustomWorkdaysRequest
 */
export type ListCustomWorkdaysRequest = Message<"legebill.site.post_expectation.v4.ListCustomWorkdaysRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListCustomWorkdaysRequest.
 * Use `create(ListCustomWorkdaysRequestSchema)` to create a new message.
 */
export const ListCustomWorkdaysRequestSchema: GenMessage<ListCustomWorkdaysRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 19);

/**
 * @generated from message legebill.site.post_expectation.v4.ListCustomWorkdaysResponse
 */
export type ListCustomWorkdaysResponse = Message<"legebill.site.post_expectation.v4.ListCustomWorkdaysResponse"> & {
  /**
   * only users with custom_workdays defined will be returned
   *
   * @generated from field: repeated legebill.site.post_expectation.v4.MemberCustomWorkdays member_custom_workdays = 2;
   */
  memberCustomWorkdays: MemberCustomWorkdays[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListCustomWorkdaysResponse.
 * Use `create(ListCustomWorkdaysResponseSchema)` to create a new message.
 */
export const ListCustomWorkdaysResponseSchema: GenMessage<ListCustomWorkdaysResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 20);

/**
 * @generated from message legebill.site.post_expectation.v4.MemberCustomWorkdays
 */
export type MemberCustomWorkdays = Message<"legebill.site.post_expectation.v4.MemberCustomWorkdays"> & {
  /**
   * @generated from field: string membership_id = 1;
   */
  membershipId: string;

  /**
   * a sparse list: example if custom Mon-Tue set for user, custom_workdays.length() == 2
   *
   * @generated from field: repeated legebill.type.Workday custom_workdays = 2;
   */
  customWorkdays: Workday[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.MemberCustomWorkdays.
 * Use `create(MemberCustomWorkdaysSchema)` to create a new message.
 */
export const MemberCustomWorkdaysSchema: GenMessage<MemberCustomWorkdays> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 21);

/**
 * @generated from message legebill.site.post_expectation.v4.Leave
 */
export type Leave = Message<"legebill.site.post_expectation.v4.Leave"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string site_id = 2;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 3;
   */
  membershipId: string;

  /**
   * @generated from field: google.type.Date date = 4;
   */
  date?: Date;

  /**
   * @generated from field: legebill.site.post_expectation.v4.LeaveAmount amount = 5;
   */
  amount: LeaveAmount;
};

/**
 * Describes the message legebill.site.post_expectation.v4.Leave.
 * Use `create(LeaveSchema)` to create a new message.
 */
export const LeaveSchema: GenMessage<Leave> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 22);

/**
 * @generated from message legebill.site.post_expectation.v4.ListMemberExpectationsRequest
 */
export type ListMemberExpectationsRequest = Message<"legebill.site.post_expectation.v4.ListMemberExpectationsRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;

  /**
   * Dates inclusive in range.
   *
   * @generated from field: google.type.Date start_date = 3;
   */
  startDate?: Date;

  /**
   * @generated from field: google.type.Date end_date = 4;
   */
  endDate?: Date;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListMemberExpectationsRequest.
 * Use `create(ListMemberExpectationsRequestSchema)` to create a new message.
 */
export const ListMemberExpectationsRequestSchema: GenMessage<ListMemberExpectationsRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 23);

/**
 * @generated from message legebill.site.post_expectation.v4.ListMemberExpectationsResponse
 */
export type ListMemberExpectationsResponse = Message<"legebill.site.post_expectation.v4.ListMemberExpectationsResponse"> & {
  /**
   * @generated from field: repeated legebill.site.post_expectation.v4.MemberExpectation member_expectations = 1;
   */
  memberExpectations: MemberExpectation[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListMemberExpectationsResponse.
 * Use `create(ListMemberExpectationsResponseSchema)` to create a new message.
 */
export const ListMemberExpectationsResponseSchema: GenMessage<ListMemberExpectationsResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 24);

/**
 * A MemberExpectation is derived from a site's PostExpectation. The site's
 * PostExpectation's standard workdays are overridden with the member's custom
 * workdays if any are configured for the user.
 * This contains the expected work hours per day (including leaves) of the
 * member for the entire duration of the PostExpectation.
 *
 * @generated from message legebill.site.post_expectation.v4.MemberExpectation
 */
export type MemberExpectation = Message<"legebill.site.post_expectation.v4.MemberExpectation"> & {
  /**
   * @generated from field: string membership_id = 1;
   */
  membershipId: string;

  /**
   * The related PostExpectation resource from which this member expectation is derived.
   *
   * @generated from field: string post_expectation_id = 2;
   */
  postExpectationId: string;

  /**
   * Known expectations, by date.
   *
   * @generated from field: repeated legebill.site.post_expectation.v4.DayExpectation day_expectations = 3;
   */
  dayExpectations: DayExpectation[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.MemberExpectation.
 * Use `create(MemberExpectationSchema)` to create a new message.
 */
export const MemberExpectationSchema: GenMessage<MemberExpectation> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 25);

/**
 * @generated from message legebill.site.post_expectation.v4.DayExpectation
 */
export type DayExpectation = Message<"legebill.site.post_expectation.v4.DayExpectation"> & {
  /**
   * @generated from field: google.type.Date date = 1;
   */
  date?: Date;

  /**
   * Expected work hours for this day.
   * Leave is taken into account. Leave decreases the expected hours for the day.
   * Expressed as percentage points, default 650 (6.5). Value will be <= 2400.
   *
   * @generated from field: uint32 work_hours_pts = 2;
   */
  workHoursPts: number;

  /**
   * None if included leave amount is unspecified.
   *
   * @generated from field: legebill.site.post_expectation.v4.LeaveAmount included_leave = 3;
   */
  includedLeave: LeaveAmount;

  /**
   * @generated from field: uint32 leave_hours_pts = 4;
   */
  leaveHoursPts: number;
};

/**
 * Describes the message legebill.site.post_expectation.v4.DayExpectation.
 * Use `create(DayExpectationSchema)` to create a new message.
 */
export const DayExpectationSchema: GenMessage<DayExpectation> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 26);

/**
 * @generated from message legebill.site.post_expectation.v4.CreateLeaveRequest
 */
export type CreateLeaveRequest = Message<"legebill.site.post_expectation.v4.CreateLeaveRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;

  /**
   * @generated from field: google.type.Date date = 3;
   */
  date?: Date;

  /**
   * @generated from field: legebill.site.post_expectation.v4.LeaveAmount amount = 4;
   */
  amount: LeaveAmount;
};

/**
 * Describes the message legebill.site.post_expectation.v4.CreateLeaveRequest.
 * Use `create(CreateLeaveRequestSchema)` to create a new message.
 */
export const CreateLeaveRequestSchema: GenMessage<CreateLeaveRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 27);

/**
 * @generated from message legebill.site.post_expectation.v4.ListLeavesRequest
 */
export type ListLeavesRequest = Message<"legebill.site.post_expectation.v4.ListLeavesRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;

  /**
   * Dates inclusive in range.
   *
   * @generated from field: google.type.Date start_date = 3;
   */
  startDate?: Date;

  /**
   * @generated from field: google.type.Date end_date = 4;
   */
  endDate?: Date;
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListLeavesRequest.
 * Use `create(ListLeavesRequestSchema)` to create a new message.
 */
export const ListLeavesRequestSchema: GenMessage<ListLeavesRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 28);

/**
 * @generated from message legebill.site.post_expectation.v4.ListLeavesResponse
 */
export type ListLeavesResponse = Message<"legebill.site.post_expectation.v4.ListLeavesResponse"> & {
  /**
   * @generated from field: repeated legebill.site.post_expectation.v4.Leave leaves = 1;
   */
  leaves: Leave[];
};

/**
 * Describes the message legebill.site.post_expectation.v4.ListLeavesResponse.
 * Use `create(ListLeavesResponseSchema)` to create a new message.
 */
export const ListLeavesResponseSchema: GenMessage<ListLeavesResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 29);

/**
 * @generated from message legebill.site.post_expectation.v4.DeleteLeaveRequest
 */
export type DeleteLeaveRequest = Message<"legebill.site.post_expectation.v4.DeleteLeaveRequest"> & {
  /**
   * @generated from field: string site_id = 1;
   */
  siteId: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.DeleteLeaveRequest.
 * Use `create(DeleteLeaveRequestSchema)` to create a new message.
 */
export const DeleteLeaveRequestSchema: GenMessage<DeleteLeaveRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 30);

/**
 * @generated from message legebill.site.post_expectation.v4.UnsubscribeRemindersRequest
 */
export type UnsubscribeRemindersRequest = Message<"legebill.site.post_expectation.v4.UnsubscribeRemindersRequest"> & {
  /**
   * @generated from field: string post_expectation_id = 1;
   */
  postExpectationId: string;

  /**
   * @generated from field: string membership_id = 2;
   */
  membershipId: string;
};

/**
 * Describes the message legebill.site.post_expectation.v4.UnsubscribeRemindersRequest.
 * Use `create(UnsubscribeRemindersRequestSchema)` to create a new message.
 */
export const UnsubscribeRemindersRequestSchema: GenMessage<UnsubscribeRemindersRequest> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 31);

/**
 * @generated from message legebill.site.post_expectation.v4.UnsubscribeRemindersResponse
 */
export type UnsubscribeRemindersResponse = Message<"legebill.site.post_expectation.v4.UnsubscribeRemindersResponse"> & {
  /**
   * @generated from field: legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus status = 1;
   */
  status: UnsubscribeRemindersResponse_UnsubscribeRemindersStatus;
};

/**
 * Describes the message legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.
 * Use `create(UnsubscribeRemindersResponseSchema)` to create a new message.
 */
export const UnsubscribeRemindersResponseSchema: GenMessage<UnsubscribeRemindersResponse> = /*@__PURE__*/
  messageDesc(file_legebill_site_postexpectation_v4_post_expectation, 32);

/**
 * @generated from enum legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus
 */
export enum UnsubscribeRemindersResponse_UnsubscribeRemindersStatus {
  /**
   * @generated from enum value: UNSUBSCRIBE_REMINDERS_UNSPECIFIED = 0;
   */
  UNSUBSCRIBE_REMINDERS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SUCCESS = 1;
   */
  SUCCESS = 1,
}

/**
 * Describes the enum legebill.site.post_expectation.v4.UnsubscribeRemindersResponse.UnsubscribeRemindersStatus.
 */
export const UnsubscribeRemindersResponse_UnsubscribeRemindersStatusSchema: GenEnum<UnsubscribeRemindersResponse_UnsubscribeRemindersStatus> = /*@__PURE__*/
  enumDesc(file_legebill_site_postexpectation_v4_post_expectation, 32, 0);

/**
 * @generated from enum legebill.site.post_expectation.v4.LeaveAmount
 */
export enum LeaveAmount {
  /**
   * @generated from enum value: LEAVE_AMOUNT_UNSPECIFIED = 0;
   */
  LEAVE_AMOUNT_UNSPECIFIED = 0,

  /**
   * @generated from enum value: HALF_DAY = 1;
   */
  HALF_DAY = 1,

  /**
   * @generated from enum value: FULL_DAY = 2;
   */
  FULL_DAY = 2,
}

/**
 * Describes the enum legebill.site.post_expectation.v4.LeaveAmount.
 */
export const LeaveAmountSchema: GenEnum<LeaveAmount> = /*@__PURE__*/
  enumDesc(file_legebill_site_postexpectation_v4_post_expectation, 0);

/**
 * @generated from service legebill.site.post_expectation.v4.PostExpectationService
 */
export const PostExpectationService: GenService<{
  /**
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.CreatePostExpectation
   */
  createPostExpectation: {
    methodKind: "unary";
    input: typeof CreatePostExpectationRequestSchema;
    output: typeof PostExpectationSchema;
  },
  /**
   * Handle member list type change e.g. from INCLUDE to EXCLUDE
   * Required member list changes are determined by the backend and returned to the caller
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ChangeMemberListType
   */
  changeMemberListType: {
    methodKind: "unary";
    input: typeof ChangeMemberListTypeRequestSchema;
    output: typeof PostExpectationSchema;
  },
  /**
   * Add site member to the post expectation member list.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.AddToMemberList
   */
  addToMemberList: {
    methodKind: "unary";
    input: typeof AddToMemberListRequestSchema;
    output: typeof AddToMemberListResponseSchema;
  },
  /**
   * Remove site member from the post expectation member list.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.RemoveFromMemberList
   */
  removeFromMemberList: {
    methodKind: "unary";
    input: typeof RemoveFromMemberListRequestSchema;
    output: typeof RemoveFromMemberListResponseSchema;
  },
  /**
   * List all active post expectations.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ListPostExpectations
   */
  listPostExpectations: {
    methodKind: "unary";
    input: typeof ListPostExpectationsRequestSchema;
    output: typeof ListPostExpectationsResponseSchema;
  },
  /**
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.AddSummaryRecipient
   */
  addSummaryRecipient: {
    methodKind: "unary";
    input: typeof AddSummaryRecipientRequestSchema;
    output: typeof AddSummaryRecipientResponseSchema;
  },
  /**
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.RemoveSummaryRecipient
   */
  removeSummaryRecipient: {
    methodKind: "unary";
    input: typeof RemoveSummaryRecipientRequestSchema;
    output: typeof RemoveSummaryRecipientResponseSchema;
  },
  /**
   * Archive a post expectation.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ArchivePostExpectation
   */
  archivePostExpectation: {
    methodKind: "unary";
    input: typeof ArchivePostExpectationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * For a post expectation, configure standard work hours for a day of the week.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.SetStandardWorkday
   */
  setStandardWorkday: {
    methodKind: "unary";
    input: typeof SetStandardWorkdayRequestSchema;
    output: typeof WorkdaySchema;
  },
  /**
   * For a membership, configure custom work hours for a day of the week.
   * Overrides the corresponding standard workday in a post expectation.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.SetCustomWorkday
   */
  setCustomWorkday: {
    methodKind: "unary";
    input: typeof SetCustomWorkdayRequestSchema;
    output: typeof WorkdaySchema;
  },
  /**
   * For a membership, unset --all-- custom workdays, so that the membership again defaults
   * to whatever is defined in the post expectation(s) for team
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.UnsetCustomWorkdays
   */
  unsetCustomWorkdays: {
    methodKind: "unary";
    input: typeof UnsetCustomWorkdaysRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ListCustomWorkdays
   */
  listCustomWorkdays: {
    methodKind: "unary";
    input: typeof ListCustomWorkdaysRequestSchema;
    output: typeof ListCustomWorkdaysResponseSchema;
  },
  /**
   * List expected hours for a day for a membership_id.
   * The membership_id must belong to the current user.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ListMemberExpectations
   */
  listMemberExpectations: {
    methodKind: "unary";
    input: typeof ListMemberExpectationsRequestSchema;
    output: typeof ListMemberExpectationsResponseSchema;
  },
  /**
   * Create leave for a member.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.CreateLeave
   */
  createLeave: {
    methodKind: "unary";
    input: typeof CreateLeaveRequestSchema;
    output: typeof LeaveSchema;
  },
  /**
   * List leaves for a member.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.ListLeaves
   */
  listLeaves: {
    methodKind: "unary";
    input: typeof ListLeavesRequestSchema;
    output: typeof ListLeavesResponseSchema;
  },
  /**
   * Delete leave.
   *
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.DeleteLeave
   */
  deleteLeave: {
    methodKind: "unary";
    input: typeof DeleteLeaveRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * @generated from rpc legebill.site.post_expectation.v4.PostExpectationService.UnsubscribeReminders
   */
  unsubscribeReminders: {
    methodKind: "unary";
    input: typeof UnsubscribeRemindersRequestSchema;
    output: typeof UnsubscribeRemindersResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_legebill_site_postexpectation_v4_post_expectation, 0);

